<app-mat-spinner-overlay *ngIf="loading" overlay="true"></app-mat-spinner-overlay>
<span *ngIf="!loading">
  <div class="quick-fadey" style="height: 15%">
    <app-character [character]="character"></app-character>
  </div>
  <div class="d-flex justify-content-between w-100 mt-3 pl-1 pr-1 quick-fadey" style="height: 85%">
    <div class="info-box pb-3 pr-4 pl-4">
      <app-inventory [characterName]="characterName" [inventory]="inventory"></app-inventory>
    </div>

    <div class="info-box pb-3 pr-4 pl-4">
      <app-stats [character]="character"></app-stats>
    </div>

    <div class="info-box pb-3 pr-4 pl-4">
      <app-spells-and-abilities [characterName]="characterName"
                                [spellsAndAbilities]="spellsAndAbilities"></app-spells-and-abilities>
    </div>
  </div>
</span>
